import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { JourneyService } from './core/services/journey.service';
import { RouterOutlet } from '@angular/router';
import { PwaInstallComponent } from './shared/components/pwa-install/pwa-install.component';
import { PwaUpdateComponent } from './shared/components/pwa-update/pwa-update.component';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { GlobalSpinnerComponent } from './shared/components/global-spinner/global-spinner.component';
import { DialogHostComponent } from './shared/components/dialog-host/dialog-host.component';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        PwaInstallComponent,
        PwaUpdateComponent,
        ToastContainerComponent,
        GlobalSpinnerComponent,
        DialogHostComponent
    ],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    // Owner-only user-journey log (screens, buttons, pop-ups, errors) — records only while someone is signed in.
    inject(JourneyService).start();
  }
}
